export const MAX_SIZE_UPLOAD = 104857600; //100MB